export default __webpack_public_path__ + "static/media/tela_finops.443b5dd6.png";